module.exports = __webpack_public_path__ + "static/media/ship-icon.f1d94ff4.svg";